module.exports = __webpack_public_path__ + "static/media/Avatar1.dd3b61f3.svg";